import { useCurrentStateAndParams } from "@uirouter/react";

import EngagementOverviewTable from "app/components/React/EngagementOverviewTable/EngagementOverviewTable";
import { MarketingChannelsDistribution } from "app/components/React/MarketingChannelsDistribution/MarketingChannelsDistribution";
import { WWOAllTrafficChannelsOverviewBarChartContainerSI } from "app/pages/website-analysis/traffic-sources/mmx/components/ChannelsOverviewBarChart/WWOAllTrafficChannelsOverviewBarChartContainerSI";
import { WWOTrafficEngagementWidgets } from "app/pages/website-analysis/TrafficAndEngagement/Components/Compare/WWOTrafficEngagementWidgets";
import { WWOChannelsOverviewBarChartContainerSI } from "app/pages/website-performance/components/ChannelsOverview/WWOChannelsOverviewBarChartContainerSI";
import { WWOSearchTrafficCompareContainerSI } from "app/pages/website-performance/components/SearchTraffic/compare/WWOSearchTrafficCompareContainerSI";
import { SectionHeader } from "app/pages/website-performance/components/SectionHeader";
import { WWOSocialOverviewContainerSI } from "app/pages/website-performance/components/SocialOverview/WWOSocialOverviewContainerSI";
import { WWOTopAdDestinationsContainerSI } from "app/pages/website-performance/components/TopAdDestinations/WWOTopAdDestinationsContainerSI";
import { WWOTrafficTopCountriesContainerSI } from "app/pages/website-performance/components/TopCountries/WWOTrafficTopCountriesContainerSI";
import { WWOTopPublishersTableContainerSI } from "app/pages/website-performance/components/TopPublishers/WWOTopPublishersTableContainerSI";
import { WWOTopReferringWebsitesContainerSI } from "app/pages/website-performance/components/TopReferringWebsites/WWOTopReferringWebsitesContainerSI";
import { WWOTrafficVisitsOverTimeContainerSI } from "app/pages/website-performance/components/TrafficVisitsOverTime/WWOTrafficVisitsOverTimeContainerSI";
import salesSettingsHelper from "app/pages/sales-intelligence/services/salesSettingsHelper";
import {
    EngagementOverviewTableWrapper,
    FullWidthWrapper,
    HeaderWithChannelWrapper,
    RowWrapper,
    SectionHeaderWrapper,
} from "app/pages/website-performance/StyledComponents";
import { devicesTypes } from "app/UtilitiesAndConstants/Constants/DevicesTypes";
import { WWOTopAdNetworksContainerSI } from "./TopAdNetworks/WWOTopAdNetworksContainerSI";

export const SIWorldwideOverviewCompare = ({ hideFooter = false }: { hideFooter?: boolean }) => {
    const { params } = useCurrentStateAndParams();
    const { webSource, duration } = params;

    return (
        <div className="row-fluid">
            <div className="wwo-widgets">
                <RowWrapper className="row-flex">
                    <SectionHeaderWrapper>
                        <SectionHeader sectionTitleKey="wa.wwo.section.webaudience.title" />
                    </SectionHeaderWrapper>
                    <FullWidthWrapper data-automation="traffic-engagement-widgets">
                        <WWOTrafficEngagementWidgets />
                    </FullWidthWrapper>

                    <EngagementOverviewTableWrapper data-automation="engagement-overview-table">
                        <EngagementOverviewTable showAddToDashboard={false} />
                    </EngagementOverviewTableWrapper>
                </RowWrapper>

                <RowWrapper className="row-flex pdf-page">
                    <FullWidthWrapper data-automation="traffic-visits-over-time">
                        <WWOTrafficVisitsOverTimeContainerSI hideFooter={hideFooter} />
                    </FullWidthWrapper>

                    {webSource !== devicesTypes.MOBILE ? (
                        <>
                            <SectionHeaderWrapper>
                                <SectionHeader sectionTitleKey="wa.wwo.section.geo.title" />
                            </SectionHeaderWrapper>
                            <FullWidthWrapper data-automation="top-countries">
                                <WWOTrafficTopCountriesContainerSI hideFooter={hideFooter} />
                            </FullWidthWrapper>

                            <SectionHeaderWrapper>
                                <SectionHeader sectionTitleKey="wa.wwo.section.marketingmix.title" />
                            </SectionHeaderWrapper>
                            {webSource === devicesTypes.DESKTOP || duration == "28d" ? (
                                <WWOChannelsOverviewBarChartContainerSI hideFooter={hideFooter} />
                            ) : (
                                <WWOAllTrafficChannelsOverviewBarChartContainerSI hideFooter={hideFooter} />
                            )}
                            <RowWrapper className="row-flex pdf-page">
                                <HeaderWithChannelWrapper>
                                    <SectionHeader sectionTitleKey="wwo.search.traffic.organic.section.title" />
                                    <MarketingChannelsDistribution marketingChannelsType={4} />
                                </HeaderWithChannelWrapper>
                                <FullWidthWrapper data-automation="search-traffic-organic">
                                    <WWOSearchTrafficCompareContainerSI
                                        organic
                                        hideFooter={hideFooter}
                                    />
                                </FullWidthWrapper>

                                <HeaderWithChannelWrapper>
                                    <SectionHeader sectionTitleKey="wwo.search.traffic.paid.section.title" />
                                    <MarketingChannelsDistribution marketingChannelsType={5} />
                                </HeaderWithChannelWrapper>
                                <FullWidthWrapper data-automation="search-traffic-paid">
                                    <WWOSearchTrafficCompareContainerSI
                                        organic={false}
                                        hideFooter={hideFooter}
                                    />
                                </FullWidthWrapper>
                            </RowWrapper>
                        </>
                    ) : null}
                </RowWrapper>

                {webSource !== devicesTypes.MOBILE ? (
                    <>
                        <RowWrapper className="row-flex">
                            <HeaderWithChannelWrapper>
                                <SectionHeader sectionTitleKey="analysis.sources.referrals.title" />
                                <MarketingChannelsDistribution marketingChannelsType={2} />
                            </HeaderWithChannelWrapper>
                            <FullWidthWrapper>
                                <WWOTopReferringWebsitesContainerSI hideFooter={hideFooter} />
                            </FullWidthWrapper>
                            <SectionHeaderWrapper>
                                <SectionHeader sectionTitleKey="wa.wwo.section.trafficdest.title" />
                            </SectionHeaderWrapper>
                            <FullWidthWrapper>
                                <WWOTopAdDestinationsContainerSI hideFooter={hideFooter} />
                            </FullWidthWrapper>
                        </RowWrapper>

                        <RowWrapper className="row-flex pdf-page">
                            <HeaderWithChannelWrapper>
                                <SectionHeader sectionTitleKey="analysis.sources.social.title" />
                                <MarketingChannelsDistribution marketingChannelsType={3} />
                            </HeaderWithChannelWrapper>

                            <FullWidthWrapper>
                                <WWOSocialOverviewContainerSI hideFooter={hideFooter} />
                            </FullWidthWrapper>
                        </RowWrapper>
                    </>
                ) : null}
                <RowWrapper className="row-flex pdf-page">
                    {webSource !== devicesTypes.MOBILE ? (
                        <HeaderWithChannelWrapper>
                            <SectionHeader sectionTitleKey="wa.wwo.section.displayads.title" />
                            <MarketingChannelsDistribution marketingChannelsType={6} />
                        </HeaderWithChannelWrapper>
                    ) : (
                        <SectionHeaderWrapper>
                            <SectionHeader sectionTitleKey="wa.wwo.section.displayads.title" />
                        </SectionHeaderWrapper>
                    )}
                    <FullWidthWrapper>
                        <WWOTopPublishersTableContainerSI hideFooter={hideFooter} />
                    </FullWidthWrapper>
                    {salesSettingsHelper.isSiAdNetworksFeatureEnabled && (
                        <FullWidthWrapper>
                            <WWOTopAdNetworksContainerSI hideFooter={hideFooter} />
                        </FullWidthWrapper>
                    )}
                </RowWrapper>
            </div>
        </div>
    );
};
